import { createRouter, createWebHistory } from 'vue-router'
import { authGuard } from './authGuard.js'
import Home from '../views/Home.vue'
import Medewerkers from '../views/Medewerkers.vue'
import Aanvragen from '../views/Aanvragen.vue'
import Concretiseren from '../views/Concretiseren.vue'
import Wzt from '../views/Wzt.vue'
import Beoordelen from '../views/Beoordelen.vue'
import Doen from '../views/Doen.vue'
import Admin from '../views/Admin.vue'
import Login from '../views/Login.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login',
      requiresAuth: false
    }
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Dashboard',
      requiresAuth: true,
      requiresDashboard: true
    }
  },
  {
    path: '/medewerkers',
    name: 'Medewerkers',
    component: Medewerkers,
    meta: {
      title: 'Medewerkers',
      requiresAuth: true
    }
  },
  {
    path: '/aanvragen',
    name: 'Aanvragen',
    component: Aanvragen,
    meta: {
      title: 'Aanvragen',
      requiresAuth: true
    }
  },
  {
    path: '/concretiseren',
    name: 'Concretiseren',
    component: Concretiseren,
    meta: {
      title: 'Concretiseren',
      requiresAuth: true
    }
  },
  {
    path: '/wzt',
    name: 'WZT',
    component: Wzt,
    meta: {
      title: 'WZT',
      requiresAuth: true
    }
  },
  {
    path: '/beoordelen',
    name: 'Beoordelen',
    component: Beoordelen,
    meta: {
      title: 'Beoordelen',
      requiresAuth: true
    }
  },
  {
    path: '/doen',
    name: 'Doen',
    component: Doen,
    meta: {
      title: 'Doen',
      requiresAuth: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    meta: {
      title: 'Beheer',
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'Pagina niet gevonden'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Authentication guard
router.beforeEach(authGuard)

// Handle navigation errors to prevent silent failures
router.onError(error => {
  console.error('Navigation error:', error)
  // If navigation fails, try to recover by going home
  if (router.currentRoute.value.path !== '/') {
    router.push('/').catch(() => {
      // If even home fails, do a full page reload as last resort
      window.location.href = '/'
    })
  }
})

export default router
